import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import tc from './locales/tc.json';
import sc from './locales/sc.json';

// Locale files are the initial (bundled) resources so the site renders
// instantly. When the CMS published data arrives, CMSProvider overrides
// these trees with addResourceBundle — CMS content always wins.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tc: { translation: tc },
      sc: { translation: sc },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
